<template>
  <div
    :class="{
      'document__drafting__module': $router.currentRoute.meta.collection == 'DocumentDrafting',
      'dashboard__individual__module': $router.currentRoute.meta.collection == 'DashboardIndividual',
      'timekeeping__module': $router.currentRoute.meta.collection == 'Timekeeping',
      'document__module': $router.currentRoute.meta.collection == 'Document',
      'dashboard__ceo__module': $router.currentRoute.meta.collection == 'DashboardCEO',
      'dashboard__hr__module': $router.currentRoute.meta.collection == 'DashboardHR',
      'dashboard__business__module': $router.currentRoute.meta.collection == 'DashboardBusiness',
      'business__module': $router.currentRoute.meta.collection == 'Business',
      'new__module': $router.currentRoute.meta.collection == 'News',
      'default__module': !$router.currentRoute.meta.collection,
    }"
  >
    <div class="div-loading">
      <div class="loader loader--style3">
        <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width="70px" height="70px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
          <path fill="#000" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
            <animateTransform attributeType="xml"
              attributeName="transform"
              type="rotate"
              from="0 25 25"
              to="360 25 25"
              dur="0.6s"
              repeatCount="indefinite"
            />
          </path>
        </svg>
      </div>
    </div>
    <FirebaseNotification />
    <router-view></router-view>
  </div>
</template>

<script>
import FirebaseNotification from './component/FirebaseNotification.vue';
export default {
  name: "app",
  components: {FirebaseNotification}
};
</script>

<style lang="scss">
//Import variables CSSs
@import "../src/assets/css/variables/icon.css";
@import "../src/assets/css/variables/variables.css";
@import "../src/assets/css/variables/iconSax.css";
@import "../src/assets/css/variables/iconSaxBold.css";
@import "../src/assets/css/variables/icon24.css";
// CoreUI Icons Set
@import "~@coreui/icons/css/coreui-icons.min.css";
/* Import Font Awesome Icons Set 4.7 */
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/scss/font-awesome.scss";
/* Import Simple Line Icons Set */
$simple-line-font-path: "~simple-line-icons/fonts/";
@import "~simple-line-icons/scss/simple-line-icons.scss";
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
// Import Main styles for this application
@import "assets/scss/style";
@import "../src/assets/scss/el-ui.scss";

//add new
@import "../node_modules/toastr/build/toastr.css";
@import "../node_modules/element-ui/lib/theme-chalk/index.css";
@import "../node_modules/nprogress/nprogress.css";
@import "../src/assets/scss/ladda.min.css";
@import "../src/assets/scss/nprogress.css";

// Must remain last: normalize text fonts after all application/vendor styles.
@import "../src/assets/scss/font-family";
</style>
